<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="单位代码">
              <a-input placeholder="请输入单位代码" v-debounce="searchQuery" v-model="queryParam.customerCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="单位名称">
              <a-input placeholder="请输入单位名称" v-debounce="searchQuery" v-model="queryParam.customerName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="5" :sm="24" :xl="5">
            <a-form-item label="是否启用">
              <j-multi-select-tag
                :options="[
                  {
                    label: '是',
                    value: '1'
                  },
                  {
                    label: '否',
                    value: '0'
                  }
                ]"
                @change="searchQuery"
                type="checkbox"
                v-model="queryParam.activated"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('送水用户单位')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="activated" slot-scope="text, record">
          <a-switch
          :checked="record.activated !== '0'"
          @change="handleActivated(record.id, record.activated === '0' ? 1 : 0)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <wf-consumer-corp-customer-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-corp-customer-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { putAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfConsumerCorpCustomerModal from './modules/WfConsumerCorpCustomerModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerCorpCustomerList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerCorpCustomerModal
    },
    data () {
      return {
        description: '送水用户单位管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '用户单位代码',
            align: "center",
            dataIndex: 'customerCode'
          },
          {
            title: '用户单位名称',
            align: "center",
            dataIndex: 'customerName'
          },
          {
            title: '联系人',
            align: "center",
            dataIndex: 'contact'
          },
          {
            title: '联系电话',
            align: "center",
            dataIndex: 'phone'
          },
          {
            title: '是否可用',
            align: "center",
            dataIndex: 'activated',
            scopedSlots: { customRender: 'activated' }
          },
          {
            title: '备注',
            align: "center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/corpCustomer/list",
          edit: "/wf/corpCustomer/edit",
          delete: "/wf/corpCustomer/delete",
          deleteBatch: "/wf/corpCustomer/deleteBatch",
          exportXlsUrl: "/wf/corpCustomer/exportXls",
          importExcelUrl: "wf/corpCustomer/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'activated', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      handleActivated (id, activated) {
        putAction(this.url.edit, { id: id, activated: activated })
          .then(res => {
            if (res.success) {
              this.$emit('ok')
              this.loadData()
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'customerCode', text: '用户单位代码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'customerName', text: '用户单位名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contact', text: '联系人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'phone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'switch', value: 'activated', text: '是否可用' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>